import { ButtonERP, TagERP } from "@finanedi.es/storybook"
import { Trans, useTranslation } from "react-i18next"

interface VerifactuExentoProps {
  showCard: boolean
  toggleOpenModal: () => void
  estadoDescripcion: string
  motivoExclusion?: string
}

export const VerifactuExento = ({
  showCard,
  toggleOpenModal,
  estadoDescripcion,
  motivoExclusion,
}: VerifactuExentoProps) => {
  const { t } = useTranslation()

  if (!showCard) return

  return (
    <div className='tw-flex tw-flex-col tw-gap-2 tw-text-left'>
      <div className='tw-flex tw-items-center tw-gap-2'>
        <span className='tw-font-medium'>Tipo:</span>
        <TagERP
          color='orange'
          value={estadoDescripcion}
        />
      </div>

      {motivoExclusion && (
        <div className='tw-flex tw-gap-2'>
          <span className='tw-font-medium'>Motivo:</span>
          <span>{motivoExclusion}</span>
        </div>
      )}

      <div className='tw-flex tw-items-center tw-justify-between tw-gap-4'>
        <div>
          <Trans
            i18nKey='verifactu.configCard.statusExeption.description'
            components={[
              <span
                className='tw-font-medium tw-contents !tw-m-0'
                key='0'
              />,
            ]}
          />
        </div>
        <div className='tw-flex-shrink-0'>
          <ButtonERP
            type='button'
            customize={{
              type: "primary",
              size: "md",
            }}
            onClick={() => toggleOpenModal()}
            label={`${t("verifactu.configCard.statusExeption.buttonLabel")}`}
          />
        </div>
      </div>
    </div>
  )
}
